"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = require("query-string");
const types_1 = require("./types");
exports.PageType = types_1.PageType;
const parser_1 = require("../parser");
const map_1 = require("./map");
const types_2 = require("../types");
const common_1 = require("../common");
function extractEzspm(link = "") {
    let e;
    try {
        const [href, qs] = link.split("?");
        const _a = query_string_1.parse(qs), { ezspm } = _a, query = __rest(_a, ["ezspm"]);
        const search = query_string_1.stringify(query);
        e = ezspm;
        link = `${href}${search ? `?${search}` : ""}`;
    }
    catch (e) {
        console.error(e);
    }
    return {
        newLink: link,
        ezspm: e,
    };
}
class Parser extends parser_1.default {
    constructor() {
        super(...arguments);
        this.schemeType = types_2.SchemeType.EzbuyApp;
        this.protocolReg = /^ezbuyapp:\/\/([\w\/]+)(?:\?([\w\W]+))?$/i;
        this.map = map_1.TypeMap;
        /**
         * 生成一个weblink
         * 相对路径转为绝对路径
         * app内新打开webview
         */
        this.genWebLink = (link, params) => {
            link = common_1.fixHttpLink(link);
            if (this.isInApp) {
                const { newLink, ezspm } = extractEzspm(link);
                return this.genAppSchemeLinkByType(types_1.PageType.Web, Object.assign({ url: newLink, ezspm }, params));
            }
            else {
                return link;
            }
        };
    }
}
exports.Parser = Parser;
